/* eslint-disable */
  // Do not edit this file, it is auto-generated at build time!
  // See scripts/bootstrap.js to modify the generation of this file.
  import Calculator from '../components/calculator/Calculator.vue';
import Chat from '../components/Feature/Customers/Chat.vue';
import CheckoutHeader from '../components/Feature/Navigation/Checkout Header.vue';
import Footer from '../components/Feature/Navigation/Footer.vue';
import Header from '../components/Feature/Navigation/Header.vue';
import ZipFlyout from '../components/Feature/Navigation/ZipFlyout.vue';
import FullPageIllustration from '../components/Feature/PageContent/Common/FullPageIllustration.vue';
import TextIllustration from '../components/Feature/PageContent/Common/TextIllustration.vue';
import TwoColumnLayout from '../components/Feature/PageContent/Layouts/TwoColumnLayout.vue';
import ContactUsOverlay from '../components/Feature/PageContent/Overlays/ContactUsOverlay.vue';
import ExitOverlay from '../components/Feature/PageContent/Overlays/ExitOverlay.vue';
import RichTextOverlay from '../components/Feature/PageContent/Overlays/RichTextOverlay.vue';
import AccountFlyout from '../components/Feature/Profile/AccountFlyout.vue';
import EchoParkLogin from '../components/Feature/Profile/EchoParkLogin.vue';
import ForgotPassword from '../components/Feature/Profile/ForgotPassword.vue';
import Registration from '../components/Feature/Profile/Registration.vue';
import AskUsModal from '../components/Feature/VehicleSearch/AskUsModal.vue';
import BodyStyleFilter from '../components/Feature/VehicleSearch/BodyStyleFilter.vue';
import ColorFilter from '../components/Feature/VehicleSearch/ColorFilter.vue';
import CtaBanner from '../components/Feature/VehicleSearch/CtaBanner.vue';
import CtaCarOffer from '../components/Feature/VehicleSearch/CtaCarOffer.vue';
import CtaTile from '../components/Feature/VehicleSearch/CtaTile.vue';
import CurrencyInput from '../components/Feature/VehicleSearch/CurrencyInput.vue';
import Disclaimer from '../components/Feature/VehicleSearch/Disclaimer.vue';
import DistanceAndShippingFilter from '../components/Feature/VehicleSearch/DistanceAndShippingFilter.vue';
import DriveTypeFilter from '../components/Feature/VehicleSearch/DriveTypeFilter.vue';
import Dropdown from '../components/Feature/VehicleSearch/Dropdown.vue';
import DynamicLinks from '../components/Feature/VehicleSearch/DynamicLinks.vue';
import FacetDealershipPicker from '../components/Feature/VehicleSearch/FacetDealershipPicker.vue';
import FacetList from '../components/Feature/VehicleSearch/FacetList.vue';
import FacetListItem from '../components/Feature/VehicleSearch/FacetListItem.vue';
import FeatureFilter from '../components/Feature/VehicleSearch/FeatureFilter.vue';
import FilterAndSortMenu from '../components/Feature/VehicleSearch/FilterAndSortMenu.vue';
import FilterChipItem from '../components/Feature/VehicleSearch/FilterChipItem.vue';
import FilterChipMenu from '../components/Feature/VehicleSearch/FilterChipMenu.vue';
import FilterMenu from '../components/Feature/VehicleSearch/FilterMenu.vue';
import FilterMenuLineItem from '../components/Feature/VehicleSearch/FilterMenuLineItem.vue';
import AskUsForm from '../components/Feature/VehicleSearch/Forms/AskUsForm.vue';
import HierarchicalFacetList from '../components/Feature/VehicleSearch/HierarchicalFacetList.vue';
import MakeModelTrimFilter from '../components/Feature/VehicleSearch/MakeModelTrimFilter.vue';
import MileageFilter from '../components/Feature/VehicleSearch/MileageFilter.vue';
import MpgEngineTypeFilter from '../components/Feature/VehicleSearch/MpgEngineTypeFilter.vue';
import NavigationButton from '../components/Feature/VehicleSearch/NavigationButton.vue';
import NoResultsScreen from '../components/Feature/VehicleSearch/NoResultsScreen.vue';
import PageNavigation from '../components/Feature/VehicleSearch/PageNavigation.vue';
import PriceFilter from '../components/Feature/VehicleSearch/PriceFilter.vue';
import RangeData from '../components/Feature/VehicleSearch/RangeData.vue';
import RangeDropdown from '../components/Feature/VehicleSearch/RangeDropdown.vue';
import RangeInput from '../components/Feature/VehicleSearch/RangeInput.vue';
import RangeSlider from '../components/Feature/VehicleSearch/RangeSlider.vue';
import RoundCheckToggleSwitch from '../components/Feature/VehicleSearch/RoundCheckToggleSwitch.vue';
import ShipToStoreToggle from '../components/Feature/VehicleSearch/ShipToStoreToggle.vue';
import ShopByStoreToggle from '../components/Feature/VehicleSearch/ShopByStoreToggle.vue';
import SrpButton from '../components/Feature/VehicleSearch/SrpButton.vue';
import StringData from '../components/Feature/VehicleSearch/StringData.vue';
import TextToggle from '../components/Feature/VehicleSearch/TextToggle.vue';
import VehicleCard from '../components/Feature/VehicleSearch/VehicleCard.vue';
import VehicleCardButtons from '../components/Feature/VehicleSearch/VehicleCardButtons.vue';
import VehicleCardCarousel from '../components/Feature/VehicleSearch/VehicleCardCarousel.vue';
import VehicleCardDetails from '../components/Feature/VehicleSearch/VehicleCardDetails.vue';
import VehicleCardLocation from '../components/Feature/VehicleSearch/VehicleCardLocation.vue';
import VehicleCardPrice from '../components/Feature/VehicleSearch/VehicleCardPrice.vue';
import VehicleResultHeading from '../components/Feature/VehicleSearch/VehicleResultHeading.vue';
import VehicleSearchResultsGrid from '../components/Feature/VehicleSearch/VehicleSearchResultsGrid.vue';
import VlpInformation from '../components/Feature/VehicleSearch/VlpInformation.vue';
import YearFilter from '../components/Feature/VehicleSearch/YearFilter.vue';
import ZipLocation from '../components/Feature/VehicleSearch/ZipLocation.vue';
import ScheduleTestDriveConfirmation from '../components/Page/ScheduleTestDrive/ScheduleTestDrive--Confirmation.vue';
import ScheduleTestDriveContact from '../components/Page/ScheduleTestDrive/ScheduleTestDrive--Contact.vue';
import ScheduleTestDriveDayAndTime from '../components/Page/ScheduleTestDrive/ScheduleTestDrive--DayAndTime.vue';
import ScheduleTestDriveVehicleAndLocation from '../components/Page/ScheduleTestDrive/ScheduleTestDrive--VehicleAndLocation.vue';
import ScheduleTestDriveVehicleInfo from '../components/Page/ScheduleTestDrive/ScheduleTestDrive--VehicleInfo.vue';
import ScheduleTestDrive from '../components/Page/ScheduleTestDrive/ScheduleTestDrive.vue';
import BuyerAddress from '../components/Page/StandaloneCreditApp/Forms/BuyerAddress.vue';
import BuyerAddressDetails from '../components/Page/StandaloneCreditApp/Forms/BuyerAddressDetails.vue';
import BuyerIdentity from '../components/Page/StandaloneCreditApp/Forms/BuyerIdentity.vue';
import EmploymentDetailsForm from '../components/Page/StandaloneCreditApp/Forms/EmploymentDetailsForm.vue';
import EmploymentDetailsFormContainer from '../components/Page/StandaloneCreditApp/Forms/EmploymentDetailsFormContainer.vue';
import PersonalDetailsForm from '../components/Page/StandaloneCreditApp/Forms/PersonalDetailsForm.vue';
import SocialSecurity from '../components/Page/StandaloneCreditApp/Forms/SocialSecurity.vue';
import FormHeader from '../components/Page/StandaloneCreditApp/Includes/FormHeader.vue';
import StandaloneCreditAppHeader from '../components/Page/StandaloneCreditApp/Includes/StandaloneCreditAppHeader.vue';
import SubmitAdditionalDetails from '../components/Page/StandaloneCreditApp/Includes/Submit--AdditionalDetails.vue';
import SubmitApplicantDetails from '../components/Page/StandaloneCreditApp/Includes/Submit--ApplicantDetails.vue';
import SubmitEmploymentDetails from '../components/Page/StandaloneCreditApp/Includes/Submit--EmploymentDetails.vue';
import SubmitEmploymentSection from '../components/Page/StandaloneCreditApp/Includes/Submit--EmploymentSection.vue';
import SubmitPanelHeader from '../components/Page/StandaloneCreditApp/Includes/Submit--PanelHeader.vue';
import SubmitStore from '../components/Page/StandaloneCreditApp/Includes/Submit--Store.vue';
import StandaloneCreditAppAdditionalInfo from '../components/Page/StandaloneCreditApp/StandaloneCreditApp--AdditionalInfo.vue';
import StandaloneCreditAppCoApplicantEmployment from '../components/Page/StandaloneCreditApp/StandaloneCreditApp--CoApplicantEmployment.vue';
import StandaloneCreditAppCoApplicantPersonalDetails from '../components/Page/StandaloneCreditApp/StandaloneCreditApp--CoApplicantPersonalDetails.vue';
import StandaloneCreditAppEmployment from '../components/Page/StandaloneCreditApp/StandaloneCreditApp--Employment.vue';
import StandaloneCreditAppFinish from '../components/Page/StandaloneCreditApp/StandaloneCreditApp--Finish.vue';
import StandaloneCreditAppPersonalDetails from '../components/Page/StandaloneCreditApp/StandaloneCreditApp--PersonalDetails.vue';
import StandaloneCreditAppStart from '../components/Page/StandaloneCreditApp/StandaloneCreditApp--Start.vue';
import StandaloneCreditAppStore from '../components/Page/StandaloneCreditApp/StandaloneCreditApp--Store.vue';
import StandaloneCreditAppSubmit from '../components/Page/StandaloneCreditApp/StandaloneCreditApp--Submit.vue';
import StandaloneCreditAppContainer from '../components/Page/StandaloneCreditApp/StandaloneCreditAppContainer.vue';
import StandaloneCreditAppSchemaForm from '../components/Page/StandaloneCreditApp/StandaloneCreditAppSchemaForm.vue';
import StyleGuideBorderRadius from '../components/Page/StyleGuide/StyleGuide--BorderRadius.vue';
import StyleGuideBorderWidth from '../components/Page/StyleGuide/StyleGuide--BorderWidth.vue';
import StyleGuideBreakpoints from '../components/Page/StyleGuide/StyleGuide--Breakpoints.vue';
import StyleGuideButtons from '../components/Page/StyleGuide/StyleGuide--Buttons.vue';
import StyleGuideColors from '../components/Page/StyleGuide/StyleGuide--Colors.vue';
import StyleGuideFormsAndInputs from '../components/Page/StyleGuide/StyleGuide--FormsAndInputs.vue';
import StyleGuideOpacityLevels from '../components/Page/StyleGuide/StyleGuide--OpacityLevels.vue';
import StyleGuideShadows from '../components/Page/StyleGuide/StyleGuide--Shadows.vue';
import StyleGuideSpacingHorizontal from '../components/Page/StyleGuide/StyleGuide--SpacingHorizontal.vue';
import StyleGuideSpacingInset from '../components/Page/StyleGuide/StyleGuide--SpacingInset.vue';
import StyleGuideSpacingVertical from '../components/Page/StyleGuide/StyleGuide--SpacingVertical.vue';
import StyleGuideTooltips from '../components/Page/StyleGuide/StyleGuide--Tooltips.vue';
import StyleGuideTypography from '../components/Page/StyleGuide/StyleGuide--Typography.vue';
import StyleGuide from '../components/Page/StyleGuide/StyleGuide.vue';
import VehicleSearchContainer from '../components/Page/VehicleSearchContainer/VehicleSearchContainer.vue';
  
  const components = new Map();
  components.set('Calculator', Calculator);
components.set('Chat', Chat);
components.set('Checkout Header', CheckoutHeader);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('ZipFlyout', ZipFlyout);
components.set('FullPageIllustration', FullPageIllustration);
components.set('TextIllustration', TextIllustration);
components.set('TwoColumnLayout', TwoColumnLayout);
components.set('ContactUsOverlay', ContactUsOverlay);
components.set('ExitOverlay', ExitOverlay);
components.set('RichTextOverlay', RichTextOverlay);
components.set('AccountFlyout', AccountFlyout);
components.set('EchoParkLogin', EchoParkLogin);
components.set('ForgotPassword', ForgotPassword);
components.set('Registration', Registration);
components.set('AskUsModal', AskUsModal);
components.set('BodyStyleFilter', BodyStyleFilter);
components.set('ColorFilter', ColorFilter);
components.set('CtaBanner', CtaBanner);
components.set('CtaCarOffer', CtaCarOffer);
components.set('CtaTile', CtaTile);
components.set('CurrencyInput', CurrencyInput);
components.set('Disclaimer', Disclaimer);
components.set('DistanceAndShippingFilter', DistanceAndShippingFilter);
components.set('DriveTypeFilter', DriveTypeFilter);
components.set('Dropdown', Dropdown);
components.set('DynamicLinks', DynamicLinks);
components.set('FacetDealershipPicker', FacetDealershipPicker);
components.set('FacetList', FacetList);
components.set('FacetListItem', FacetListItem);
components.set('FeatureFilter', FeatureFilter);
components.set('FilterAndSortMenu', FilterAndSortMenu);
components.set('FilterChipItem', FilterChipItem);
components.set('FilterChipMenu', FilterChipMenu);
components.set('FilterMenu', FilterMenu);
components.set('FilterMenuLineItem', FilterMenuLineItem);
components.set('AskUsForm', AskUsForm);
components.set('HierarchicalFacetList', HierarchicalFacetList);
components.set('MakeModelTrimFilter', MakeModelTrimFilter);
components.set('MileageFilter', MileageFilter);
components.set('MpgEngineTypeFilter', MpgEngineTypeFilter);
components.set('NavigationButton', NavigationButton);
components.set('NoResultsScreen', NoResultsScreen);
components.set('PageNavigation', PageNavigation);
components.set('PriceFilter', PriceFilter);
components.set('RangeData', RangeData);
components.set('RangeDropdown', RangeDropdown);
components.set('RangeInput', RangeInput);
components.set('RangeSlider', RangeSlider);
components.set('RoundCheckToggleSwitch', RoundCheckToggleSwitch);
components.set('ShipToStoreToggle', ShipToStoreToggle);
components.set('ShopByStoreToggle', ShopByStoreToggle);
components.set('SrpButton', SrpButton);
components.set('StringData', StringData);
components.set('TextToggle', TextToggle);
components.set('VehicleCard', VehicleCard);
components.set('VehicleCardButtons', VehicleCardButtons);
components.set('VehicleCardCarousel', VehicleCardCarousel);
components.set('VehicleCardDetails', VehicleCardDetails);
components.set('VehicleCardLocation', VehicleCardLocation);
components.set('VehicleCardPrice', VehicleCardPrice);
components.set('VehicleResultHeading', VehicleResultHeading);
components.set('VehicleSearchResultsGrid', VehicleSearchResultsGrid);
components.set('VlpInformation', VlpInformation);
components.set('YearFilter', YearFilter);
components.set('ZipLocation', ZipLocation);
components.set('ScheduleTestDrive--Confirmation', ScheduleTestDriveConfirmation);
components.set('ScheduleTestDrive--Contact', ScheduleTestDriveContact);
components.set('ScheduleTestDrive--DayAndTime', ScheduleTestDriveDayAndTime);
components.set('ScheduleTestDrive--VehicleAndLocation', ScheduleTestDriveVehicleAndLocation);
components.set('ScheduleTestDrive--VehicleInfo', ScheduleTestDriveVehicleInfo);
components.set('ScheduleTestDrive', ScheduleTestDrive);
components.set('BuyerAddress', BuyerAddress);
components.set('BuyerAddressDetails', BuyerAddressDetails);
components.set('BuyerIdentity', BuyerIdentity);
components.set('EmploymentDetailsForm', EmploymentDetailsForm);
components.set('EmploymentDetailsFormContainer', EmploymentDetailsFormContainer);
components.set('PersonalDetailsForm', PersonalDetailsForm);
components.set('SocialSecurity', SocialSecurity);
components.set('FormHeader', FormHeader);
components.set('StandaloneCreditAppHeader', StandaloneCreditAppHeader);
components.set('Submit--AdditionalDetails', SubmitAdditionalDetails);
components.set('Submit--ApplicantDetails', SubmitApplicantDetails);
components.set('Submit--EmploymentDetails', SubmitEmploymentDetails);
components.set('Submit--EmploymentSection', SubmitEmploymentSection);
components.set('Submit--PanelHeader', SubmitPanelHeader);
components.set('Submit--Store', SubmitStore);
components.set('StandaloneCreditApp--AdditionalInfo', StandaloneCreditAppAdditionalInfo);
components.set('StandaloneCreditApp--CoApplicantEmployment', StandaloneCreditAppCoApplicantEmployment);
components.set('StandaloneCreditApp--CoApplicantPersonalDetails', StandaloneCreditAppCoApplicantPersonalDetails);
components.set('StandaloneCreditApp--Employment', StandaloneCreditAppEmployment);
components.set('StandaloneCreditApp--Finish', StandaloneCreditAppFinish);
components.set('StandaloneCreditApp--PersonalDetails', StandaloneCreditAppPersonalDetails);
components.set('StandaloneCreditApp--Start', StandaloneCreditAppStart);
components.set('StandaloneCreditApp--Store', StandaloneCreditAppStore);
components.set('StandaloneCreditApp--Submit', StandaloneCreditAppSubmit);
components.set('StandaloneCreditAppContainer', StandaloneCreditAppContainer);
components.set('StandaloneCreditAppSchemaForm', StandaloneCreditAppSchemaForm);
components.set('StyleGuide--BorderRadius', StyleGuideBorderRadius);
components.set('StyleGuide--BorderWidth', StyleGuideBorderWidth);
components.set('StyleGuide--Breakpoints', StyleGuideBreakpoints);
components.set('StyleGuide--Buttons', StyleGuideButtons);
components.set('StyleGuide--Colors', StyleGuideColors);
components.set('StyleGuide--FormsAndInputs', StyleGuideFormsAndInputs);
components.set('StyleGuide--OpacityLevels', StyleGuideOpacityLevels);
components.set('StyleGuide--Shadows', StyleGuideShadows);
components.set('StyleGuide--SpacingHorizontal', StyleGuideSpacingHorizontal);
components.set('StyleGuide--SpacingInset', StyleGuideSpacingInset);
components.set('StyleGuide--SpacingVertical', StyleGuideSpacingVertical);
components.set('StyleGuide--Tooltips', StyleGuideTooltips);
components.set('StyleGuide--Typography', StyleGuideTypography);
components.set('StyleGuide', StyleGuide);
components.set('VehicleSearchContainer', VehicleSearchContainer);
  
  export default function componentFactory(componentName: String): any {
    return components.get(componentName);
  };
  